<div class="container">
  <div class="headerContainer">
    <h1><b>MIPS File Repository</b></h1>
  </div>

  <div class="content">
    <ag-grid-angular
      style="width: 100%; height: 70vh"
      [columnDefs]="colDefs"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      (gridReady)="onGridReady($event)"
      [theme]="theme"
      [gridOptions]="gridOptions"
      (cellClicked)="onCellClicked($event)"
    />
  </div>
</div>
